import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { AuthContext } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL || '';

async function createSession(user) {
  const idToken = await user.getIdToken();
  await axios.post(`${API}/api/auth/session-login`, { idToken }, { withCredentials: true });
}

export default function Auth() {
  const [email, setEmail]   = useState('');
  const [password, setPass] = useState('');
  const [error, setError]   = useState('');
  const navigate            = useNavigate();
  const { currentUser }     = useContext(AuthContext);

  if (currentUser) { navigate('/dashboard'); return null; }

  const doLogin = async () => {
    setError('');
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      await createSession(cred.user);
      navigate('/dashboard');
    } catch { setError('Courriel ou mot de passe invalide'); }
  };

  return (
    <div style={s.page}>
      <div style={s.box}>
        <div style={s.logo}>U</div>
        <h2 style={s.h2}>Espace Ucreative</h2>
        <p style={s.sub}>Connectez-vous pour accéder au tableau de bord</p>
        {error && <div style={s.error}>{error}</div>}
        <div style={s.group}>
          <label style={s.label}>Adresse courriel</label>
          <input style={s.input} type="email" placeholder="vous@exemple.com"
            value={email} onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && doLogin()} />
        </div>
        <div style={s.group}>
          <label style={s.label}>Mot de passe</label>
          <input style={s.input} type="password" placeholder="••••••••"
            value={password} onChange={e => setPass(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && doLogin()} />
        </div>
        <button style={s.submit} onClick={doLogin}>Se connecter</button>
        <p style={s.hint}>Vous n'avez pas de compte ? Contactez l'administrateur.</p>
      </div>
    </div>
  );
}

const s = {
  page:   { background:'#080808', minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 20px' },
  box:    { background:'#111', border:'1px solid rgba(255,255,255,0.08)', borderRadius:24, padding:'48px', width:'100%', maxWidth:420 },
  logo:   { width:48, height:48, borderRadius:12, background:'#C8FF00', color:'#000', fontWeight:900, fontSize:'1.4rem', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:20 },
  h2:     { fontSize:'1.7rem', fontWeight:800, marginBottom:6, color:'#F0F0F0' },
  sub:    { color:'#555', fontSize:'0.85rem', marginBottom:32 },
  error:  { background:'rgba(248,113,113,0.08)', border:'1px solid rgba(248,113,113,0.2)', borderRadius:8, padding:'12px', color:'#f87171', fontSize:'0.83rem', marginBottom:16 },
  group:  { marginBottom:18 },
  label:  { display:'block', fontSize:'0.78rem', color:'#555', marginBottom:7, fontWeight:600 },
  input:  { width:'100%', background:'#080808', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:'13px 14px', color:'#F0F0F0', fontSize:'0.92rem', outline:'none', boxSizing:'border-box' },
  submit: { width:'100%', background:'#C8FF00', color:'#000', border:'none', padding:'15px', borderRadius:11, fontWeight:800, fontSize:'0.95rem', cursor:'pointer', marginTop:6 },
  hint:   { color:'#2a2a2a', fontSize:'0.75rem', textAlign:'center', marginTop:20 },
};
